/*  
 *  Archivo destinado a manejar todas las funciones responsables de comunicación con 
 *  el servidor, referentes al usuario.
 */

import { useValue } from "../context/ContextProvider.js";
import uploadFile from "../firebase/uploadFile";
import { useAppStore } from "../store/appStore.tsx";
//import { useAppStore } from "../store/appStore.tsx";
import fetchData from "./utils/fetchData";
import { v4 as uuidv4 } from "uuid"

const url = process.env.REACT_APP_SERVER_URL + '/user';

export const register = async (user, dispatch) => {
    
    dispatch({ type: 'START_LOADING' });
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + '/register', body: user }, dispatch);
    const result = data.result;
    if (result) {
        dispatch({ type: 'UPDATE_USER', payload: result });
        dispatch({ type: 'CLOSE_LOGIN' });
        dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: 'Usuario creado con éxito!' } });
        //updateUser(result);
    }

    dispatch({ type: 'END_LOADING' })
}

/*
export const login = async (user, dispatch, updateUser) => {
    dispatch({ type: 'START_LOADING' });

    //SEND REQUEST WITH FETCH
    //fetchData está en "actions>utils". Se utiliza para las comunicaciones con el servidor
    const data = await fetchData({ url: url + '/login', body: user }, dispatch);    
    const result = data?.result;
    if (result) {
        dispatch({ type: 'UPDATE_USER', payload: result });
        dispatch({ type: 'CLOSE_LOGIN' });
        dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: 'Usuario logueado con éxito!' } });
        const {updateUser, showLogin, closeLogin} = useAppStore(appStore => appStore);
        dispatch({ type: 'END_LOADING' })
        updateUser(result);
    }

    dispatch({ type: 'END_LOADING' })
}
*/


export const useLogin = () => {
    const { state: { }, dispatch } = useValue();
    const { startLoading, endLoading, closeLogin, updateUser } = useAppStore(appStore => appStore);

    
    const login = async (user) => {
        //dispatch({ type: 'START_LOADING' });
        startLoading();     //Muestra el gráfico de espera durante la carga de datos

        //console.log("useLogin", user);

        //SEND REQUEST WITH FETCH
        const data = await fetchData({ url: url + '/login', body: user }, dispatch);
        const result = data?.result;
        if (result) {
            closeLogin();
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: 'Usuario logueado con éxito!' } });
            updateUser(result);
        }

        //dispatch({ type: 'END_LOADING' })
        endLoading();     //Oculta el gráfico de espera durante la carga de datos
    }

    return login;
}

export const updateProfile = async (currentUser, updatedFields, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    //SEND REQUEST WITH FETCH
    const { name, file } = updatedFields;
    let body = { name };
    let photoURL ='';
    try {
        if (file) {
            const imageName = uuidv4() + '.' + file?.name?.split('.')?.pop();
            //console.log(imageName);
            photoURL = await uploadFile(file, `profile/${currentUser?.id}/${imageName}`);
        }else {
            photoURL = currentUser.photoURL;
        }
        body = { ...body, photoURL };
        const data = await fetchData({ url: url + `/updateProfile`, method: 'PATCH', body, token: currentUser.token }, dispatch);
        const result = data?.result;
        if (result) {
            //console.log({result});
            dispatch({ type: 'UPDATE_USER', payload: { ...currentUser, ...result } });
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: data.message } });
            dispatch({ type: 'UPDATE_PROFILE', payload: { open: false, file: null, photoURL: result.photoURL } });
        } else {
            dispatch({ type: 'UPDATE_PROFILE', payload: { open: false, file: null, photoURL: '' } });
            dispatch({type: 'UPDATE_USER', payload: null});
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: "Algo salió mal con sus credenciales.Por favor intenete nuevamente en unos minutos." } });
        }

    } catch (error) {
        dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: error.message } });
        //console.log(error);
    }

    dispatch({ type: 'END_LOADING' })
}

export const getUsers = async (comando, currentUser, dispatch) => {
    //console.log('-------------->> getUsers');
    //console.log(currentUser);

    if(!currentUser)
        return;

        dispatch({ type: 'START_LOADING' });
    
    let body = { comando };

    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/getUsers`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        dispatch({ type: 'UPDATE_USERS', payload: result });      //A users se envía el payload como {rows: valor}
    } else {

    }

    dispatch({ type: 'END_LOADING' })
}

export const updateUser = async(datos, currentUser, dispatch) => {
    //dispatch({ type: 'START_LOADING' });  //porque tiene su propio control de loading

    //console.log('-------------->> updateUser');
    //console.log('Datos: ', datos);

    let body = datos;
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/updateUser`, method: 'PATCH', body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        //dispatch({ type: 'UPDATE_MARCAS', payload: result });
        //console.log('Respuesta backend (NuevaMarca): ', result);
        dispatch({ type: 'END_LOADING' })
        return result;
    } else {

    }

    //dispatch({ type: 'END_LOADING' })

}

export const changePassword = async (currentUser, passwords, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    const { currentPassword, newPassword } = passwords;
    const body = { currentPassword, newPassword };
    
    // Inicializamos como null por si la petición falla
    let updatedUser = null; 

    try {
        const data = await fetchData({ 
            url: url + `/changePassword`, 
            method: 'PATCH', 
            body, 
            token: currentUser.token 
        }, dispatch);

        console.log(`[changePassword] `, data);

        if (data && data.success !== false) {
            dispatch({ 
                type: 'UPDATE_ALERT', 
                payload: { open: true, severity: 'success', message: data.message || "Contraseña actualizada correctamente." } 
            });
            dispatch({ type: 'OPEN_PASSWORD_MODAL', payload: false });

            // Llenamos el objeto actualizado
            updatedUser = {
                ...currentUser,
                mustChangePassword: 0,
                ...(data.result?.token && { token: data.result.token })
            };

        } else {
            dispatch({ 
                type: 'UPDATE_ALERT', 
                payload: { open: true, severity: 'error', message: data.message || "Error: No se pudo actualizar la contraseña." } 
            });
        }
    } catch (error) {
        dispatch({ 
            type: 'UPDATE_ALERT', 
            payload: { open: true, severity: 'error', message:  error.message  || "Error: Ocurrió un error al procesar la solicitud." } 
        });
        //console.log(error);
    }

    dispatch({ type: 'END_LOADING' });
    
    // Retornamos el usuario (será null si falló, o el objeto si tuvo éxito)
    return updatedUser;
}